import { useQueryString } from '#src/hooks/useQueryString.ts';

export const useScrollToQueryParameter = () => useQueryString('scrollTo');
